export default class RestPaths {
  private static bestellungKundeBase = "bestellung_kunde/"
  private static filialeBase = "filiale/"
  private static kundeBase = "kunde/"
  private static nachrichtBase = "nachricht/"
  private static preislisteBase = "preisliste/"
  private static oeffnungszeitBase = "oeffnungszeit/"
  private static tischBase = "tisch/"
  private static loginBase = "login/"
  private static paymentBase = "payment/"
  private static artikelBase = "artikel/"
  private static imageBase = "images/"
  private static locationBase = "locations/"
  private static bestellungpendingBase = "bestellung_pending/"
  private static rechnungBase = "rechnung/"
  private static reservierungenBase = "reservierungen/"

  // public static imageBasePath = "http://192.168.178.51/images/"
  // public static urlBase = "http://192.168.178.51/api/rs/"
  // public static urlBaseWs = "ws://192.168.178.51/api/ws/"

  // public static imageBasePath = "http://localhost/images/"
  // public static urlBase = "http://localhost:8080/rs/"
  // public static urlBaseWs = "ws://localhost:8080/ws/"

  public static imageBasePath = "https://mangeroo.de/images/"
  public static urlBase = "https://mangeroo.de/api/rs/"
  public static urlBaseWs = "wss://mangeroo.de/api/ws/"

  public static methodPost = "POST"
  public static methodGet = "GET"
  public static modeCors = "cors"
  public static contentType = "Content-Type"
  public static applicationJson = "application/json;charset=utf-8"

  public static artikelPdukteNachZeitSingle =
    this.artikelBase + "pdukte_nach_zeit_single"
  public static artikelPdukteNachZeit = this.artikelBase + "pdukte_nach_zeit"

  public static bestellungKundeSync = this.bestellungKundeBase + "sync"
  public static bestellungKundeReservierungEinbuchen =
    this.bestellungKundeBase + "reservierung_einbuchen"
  public static bestellungKundeEinfuegen =
    this.bestellungKundeBase + "einfuegen"
  public static bestellungKundeEinfuegenArtikelliste =
    this.bestellungKundeBase + "einfuegen_artikelliste"
  public static bestellungKundeDetails = this.bestellungKundeBase + "details"
  public static bestellungKundeStornieren =
    this.bestellungKundeBase + "stornieren"
  public static bestellungKundeListe = this.bestellungKundeBase + "liste"
  public static bestellungKundeListeAll = this.bestellungKundeBase + "liste_all"
  public static bestellungKundeUpdate = this.bestellungKundeBase + "update"
  public static bestellungKundeServiceAnfordern =
    this.bestellungKundeBase + "service_anfordern"
  public static bestellungKundeNachbestellungEinfuegen =
    this.bestellungKundeBase + "nachbestellung_einfuegen"
  public static bestellungKundeTischBuchen =
    this.bestellungKundeBase + "tisch_buchen"
  public static bestellungKundeTischBuchungsartWaehlen =
    this.bestellungKundeBase + "tisch_buchungsart_waehlen"
  public static bestellungKundeKundendatenLieferung =
    this.bestellungKundeBase + "kundendaten_lieferung"
  public static bestellungKundeFilialeAktuell =
    this.bestellungKundeBase + "filiale_aktuell"
  public static bestellungKundeWarenkorb =
    this.bestellungKundeBase + "warenkorb"
  public static bestellungKundeBestellungRechnung =
    this.bestellungKundeBase + "bestellung/rechnung"
  public static bestellungKundeTrinkgeldFestlegen =
    this.bestellungKundeBase + "trinkgeld_festlegen"
  public static bestellungKundeRechnungSenden =
    this.bestellungKundeBase + "sende_rechnung"

  public static bestellungpendingBeginnen =
    this.bestellungpendingBase + "beginnen"
  public static bestellungpendingBeginnenSofort =
    this.bestellungpendingBase + "beginnen_sofort"
  public static bestellungpendingAbholungTermin =
    this.bestellungpendingBase + "abholung_termin"
  public static bestellungpendingLieferungTermin =
    this.bestellungpendingBase + "lieferung_termin"
  public static bestellungpendingArtikelHinzufuegen =
    this.bestellungpendingBase + "artikel_hinzufuegen"
  public static bestellungpendingArtikelHinzufuegenNachbestellung =
    this.bestellungpendingBase + "artikel_hinzufuegen_nachbestellung"
  public static bestellungpendingLieferungKunde =
    this.bestellungpendingBase + "lieferung_kunde"
  public static bestellungpendingAbholungKunde =
    this.bestellungpendingBase + "abholung_kunde"
  public static bestellungpendingArtikelAendern =
    this.bestellungpendingBase + "artikel_aendern"
  public static bestellungpendingArtikelAendernNachbestellung =
    this.bestellungpendingBase + "artikel_aendern_nachbestellung"
  public static bestellungpendingAbholungVerzehrart =
    this.bestellungpendingBase + "abholung_verzehrart"
  public static bestellungpendingAufgeben =
    this.bestellungpendingBase + "aufgeben"
  public static bestellungpendingDetails =
    this.bestellungpendingBase + "details"
  public static bestellungpendingTrinkgeldFestlegen =
    this.bestellungpendingBase + "trinkgeld_festlegen"
  public static bestellungpendingSofortBestellart =
    this.bestellungpendingBase + "sofort_bestellart"
  public static bestellungpendingNachbestellenBeginnen =
    this.bestellungpendingBase + "beginnen_nachbestellen"
  public static bestellungpendingNachbestellungAufgeben =
    this.bestellungpendingBase + "aufgeben_nachbestellung"
  public static bestellungpendingLieferungStandort =
    this.bestellungpendingBase + "lieferung_standort"

  public static filialeListe = this.filialeBase + "liste"
  public static filialeListeSimple = this.filialeBase + "liste_simple"
  public static filialeListeBestellungSuche =
    this.filialeBase + "liste_bestellung_suche"
  public static filialeBestellungSuche = this.filialeBase + "bestellung_suche"
  public static filialeBestellungSucheTisch =
    this.filialeBase + "bestellung_suche_tisch"
  public static filialeDetails = this.filialeBase + "details"
  public static filialeDetailsMitTisch = this.filialeBase + "details_mit_tisch"
  public static filialePrintGeolocation = this.filialeBase + "print_geolocation"
  public static filialeCheckLocation = this.filialeBase + "check_location"
  public static filialeTimeZones = this.filialeBase + "time_zones"
  public static filialeCheckOeffnung = this.filialeBase + "check_oeffnung"
  public static filialeDetailed = this.filialeBase + "detailed"
  public static filialeDetailsNachPfad = this.filialeBase + "details_nach_pfad"
  public static filialeDetailsNachUrl = this.filialeBase + "details_nach_url"
  public static filialeLiefergebietStandort =
    this.filialeBase + "liefergebiet_standort"
  public static filialeAgb = this.filialeBase + "agb"
  public static filialeDatenschutz = this.filialeBase + "datenschutz"
  public static filialeImpressum = this.filialeBase + "impressum"
  public static filialeInfo = this.filialeBase + "info"

  public static kundeRegistrieren = this.kundeBase + "registrieren"
  public static kundeEinfuegen = this.kundeBase + "einfuegen"
  public static kundeBenutzerRegistrieren =
    this.kundeBase + "benutzer_registrieren"

  public static kundeEigeneDaten = this.kundeBase + "eigene_daten"
  public static kundeEigeneDatenBenutzer =
    this.kundeBase + "eigene_daten_benutzer"
  public static kundeEigeneDatenEdit = this.kundeBase + "eigene_daten_edit"
  public static kundeEigeneDatenSpeichern =
    this.kundeBase + "eigene_daten_speichern"
  public static kundePasswortAendern = this.kundeBase + "passwort_aendern"
  public static kundePasswortAendernDirekt =
    this.kundeBase + "passwort_aendern_direkt"
  public static kundePasswortVergessen = this.kundeBase + "passwort_vergessen"
  public static kundePasswortAendernValid =
    this.kundeBase + "passwort_aendern_valid"

  public static nachrichtListe = this.nachrichtBase + "liste"
  public static nachrichtDetails = this.nachrichtBase + "details"

  public static preislisteNachDatum = this.preislisteBase + "nach_datum"

  public static oeffnungszeitOeffnungszeiten =
    this.oeffnungszeitBase + "oeffnungszeiten"
  public static oeffnungszeitOeffnungszeitenLieferung =
    this.oeffnungszeitBase + "oeffnungszeiten_lieferung"
  public static oeffnungszeitOeffnungszeitenKueche =
    this.oeffnungszeitBase + "oeffnungszeiten_kueche"

  public static tischPruefen = this.tischBase + "pruefen"
  public static tischCheckFreeSlots = this.tischBase + "check_free_slots"
  public static tischMitFiliale = this.tischBase + "mit_filiale"

  public static login = this.loginBase + "login"
  public static loginUpdateFcm = this.loginBase + "update_fcm"
  public static loginUpdateToken = this.loginBase + "update_token"

  public static paymentPaypalCheckout = this.paymentBase + "paypal_checkout"
  public static paymentPaypalCheckoutNeueBestellung =
    this.paymentBase + "paypal_checkout_neue_bestellung"
  public static paymentPaypalCheckoutCheck =
    this.paymentBase + "paypal_checkout_check"
  public static paymentPaypalCheckoutComplete = this.paymentBase + "complete"
  public static paymentPaypalAbschliessen = this.paymentBase + "abschliessen"

  public static imageSaveTemp = this.imageBase + "save_temp"
  public static imageImage = this.imageBase + "image2"
  public static imageQrCode = this.imageBase + "qrcode"
  public static imageQrCodeFiliale = this.imageBase + "qrcode_filiale"
  public static imageQrCodeTischbestellung =
    this.imageBase + "qrcode_tischbestellung"

  public static locationByQuery = this.locationBase + "by_query"
  public static locationNext = this.locationBase + "next"
  public static locationListByText = this.locationBase + "list_by_text"
  public static locationListByTextOSM = this.locationBase + "list_by_text_osm"
  public static locationLocationByCoordinatesOSM =
    this.locationBase + "location_by_coordinates_osm"
  public static locationPlaceById = this.locationBase + "place_by_id"

  public static rechnungBestellung = this.rechnungBase + "bestellung"

  public static reservierungenCheckFreeSlots =
    this.reservierungenBase + "check_free_slots"
  public static reservierungenErmittleTimeSlots =
    this.reservierungenBase + "ermittle_time_slots"

  public static reservierungenPendingTerminWaehlen =
    this.reservierungenBase + "pending_termin_waehlen"
  public static reservierungenPendingKundendaten =
    this.reservierungenBase + "pending_kundendaten"
  public static reservierungenPendingBestaetigen =
    this.reservierungenBase + "pending_bestaetigen"
  public static reservierungenListKunde = this.reservierungenBase + "list_kunde"
  public static reservierungenDetailsKunde =
    this.reservierungenBase + "details_kunde"
  public static reservierungenVorbestellungBearbeiten =
    this.reservierungenBase + "vorbestellung_bearbeiten"
  public static reservierungenVorbestellungPendingBeginnen =
    this.reservierungenBase + "vorbestellung_pending_beginnen"
  public static reservierungenVorbestellungPendingArtikelHinzufuegen =
    this.reservierungenBase + "vorbestellung_pending_artikel_hinzufuegen"
  public static reservierungenVorbestellungPendingBestaetigen =
    this.reservierungenBase + "vorbestellung_pending_bestaetigen"
  public static reservierungenVorbestellungPendingArtikelAendern =
    this.reservierungenBase + "vorbestellung_pending_artikel_aendern"
}
